import { getAccessToken, getUserInfo } from "./services/tokenService.js";
import { environment } from "./enviroments/enviroment.js";
import { get } from "svelte/store";
import { sessionExpiredModalShown, locale } from "./store/stores.js";

const client_id = environment.oidc_client_id;
const redirectUrl = environment.redirectUrl;
const oidc_auth_path = environment.oidc_auth_path;
const logoutUrl = environment.logoutUrl;

export function startAuth() {
  const userSelectedLocale = get(locale);
  window.location.href = `${oidc_auth_path}?response_type=code&ui_locales=${userSelectedLocale}&client_id=${client_id}&redirect_uri=${redirectUrl}&scope=openid%20externalpermissions.query&state=976234769273492`;
}

// Tallennetaan käyttäjän tiedot localStorageen
// HUOM: tallennetaan vain ryhmät eikä koko userInfo-objektia
const setUserInfoToStorage = async () => {
  try {
    const userInfo = await getUserInfo();

    localStorage.setItem("userGroups", JSON.stringify(userInfo));
  } catch (error) {
    console.error("Käyttäjätietojen hakeminen epäonnistui:", error);
  }
};

// Tallennetaan tokenit ja kirjautumistila localStorageen
const setAccessTokenInfoToStorage = (accessInfo) => {
  localStorage.setItem("accessToken", accessInfo.access_token);
  localStorage.setItem("idToken", accessInfo.id_token);
  // tallennetaan absoluuttinen päättymisaika, ei pelkkää expires_in
  const expireAt = Date.now() + accessInfo.expires_in * 1000; //millisekunteina localstorageen
  localStorage.setItem("tokenExpireAt", expireAt.toString());
  localStorage.setItem("isLoggedIn", "true");
};

// Puhdistaa URL-palkista koodin tai virheparametrit
const clearUrlBar = () => {
  window.history.replaceState({}, document.title, window.location.pathname);
};

export const getHasAccess = async () => {
    const urlParams = new URLSearchParams(window.location.search)
    // 1) Jos kirjautumisesta palattiin on "code" olemassa
    if (urlParams.has('code')) {
        const code = urlParams.get('code')
        const accessInfo = await getAccessToken(code)

        if (accessInfo.access_token) {
            setAccessTokenInfoToStorage(accessInfo)
            await setUserInfoToStorage()
        } else {
          console.warn("Access tokenia ei saatu haettua.")
        }

        clearUrlBar()
        return isUserLoggedIn()
    }

    // 2) Jos ei tullut kirjautumisesta, tarkistetaan localStoragesta
    return isUserLoggedIn()
}

// Tarkistaa localStoragesta löytyykö vielä voimassaoleva token
export const isUserLoggedIn = () => {
    const token = localStorage.getItem('accessToken')
    const expireAt = parseInt(localStorage.getItem('tokenExpireAt'), 10)

    if (!token || !expireAt) {
        return false
    }

    if (Date.now() > expireAt) {
        clearLocalStorageValues()
        showSessionExpiredModal()
        return false
    }

    return true
}

// Näyttää session vanhentumisdialogin
const showSessionExpiredModal = () => {
  sessionExpiredModalShown.set(true);
};

// Tyhjentää kaikki kirjautumiseen liittyvät tiedot
const clearLocalStorageValues = () => {
  localStorage.removeItem("userGroups");
  localStorage.removeItem("accessToken");
  localStorage.removeItem("idToken");
  localStorage.removeItem("tokenExpireAt");
  localStorage.removeItem("isLoggedIn");
};

// Kirjaa käyttäjän ulos ja ohjaa logout-sivulle
export function logOut() {
  clearLocalStorageValues();
  window.location.href = logoutUrl;
}

let intervalId = null

export const startAuthWatcher = () => {
    //console.log("asetettu watcher")
    if (intervalId) return // estetään useampi intervalli

    intervalId = setInterval(() => {
        const loggedIn = isUserLoggedIn()
        if (!loggedIn) {
            stopAuthWatcher()
        }
       
    }, 30 * 1000) // tarkista minuutin välein
}

export const stopAuthWatcher = () => {
  //console.log("stopattu watcher")
    if (intervalId) {
        clearInterval(intervalId)
        intervalId = null
    }
}